export function handleScatterData(chartOption, res, is3D) {
  if (res.data.code === 1) {
    let datas = res.data.data.content.data
    let typeLen = datas.length
    // 里面包含两个数组分别对应经度和纬度
    // 经度数据
    let scatterDataList1 = res.data.data.content.data[0].data
    // 纬度数据
    let scatterDataList2 = res.data.data.content.data[1].data
    let newScatterData = []
    for (let i = 0; i < scatterDataList1.length; i++) {
      let obj = {
        name: "",
        value: [0, 0, is3D ? 4 : 0] //3D的散点如果第三个值给0会把地图的默认标签位置挤得很高，原因暂不明，3D时给4暂时规避一下这个问题
      }
      if (typeLen > 2) {
        for (let m = 2; m < typeLen; m++) {
          obj[`${datas[m].name}`] = ""
        }
      }
      newScatterData.push(obj)
      newScatterData[i].name = scatterDataList1[i].key
      newScatterData[i].value[0] = parseFloat(scatterDataList1[i].value)
      newScatterData[i].value[1] = parseFloat(scatterDataList2[i].value)
      if (typeLen > 2) {
        for (let m = 2; m < typeLen; m++) {
          let nameN = datas[m].name
          let obj1 = newScatterData[i]
          obj1[`${nameN}`] = datas[m].data[i].value
        }
      }
    }
    this.$changeOptionsEV(newScatterData, "chartOption.scatter.data", false)
  }
}
